import { PureComponent } from 'react'
import { func, array, number } from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { options } from './options'
import { turnOnMyLocation } from '../../../../../store/Actions/SpiActions'
import { updateLoading } from '../../../../../store/Actions/SignsActions'
import { addressBasedSearch } from '../../../../../store/Actions/MapActions'

class CurrentPositionComponent extends PureComponent {
  componentDidMount = () => {
    this.props.updateLoading(true)
    this.watchid = window.navigator.geolocation.getCurrentPosition(
      this.onSuccess,
      this.onError,
      options
    )
  }

  onSuccess = position => {
    let lat = position.coords.latitude
    let lng = position.coords.longitude
    this.props.addressBasedSearch(true)
    this.props.history.push(
      `/${lng}:${lat}/${this.props.category.join(',')}/${this.props.radius}`
    )
    this.props.turnOnMyLocation(false)
  }

  onError = error => {
    this.props.updateLoading(false)
    console.log(error.code, error.message)
  }

  componentWillUnmount = () => {
    if (this.watchid !== null) {
      window.navigator.geolocation.clearWatch(this.watchid)
      this.watchid = null
    }
    this.props.turnOnMyLocation(false)
  }

  render() {
    return null
  }
}

CurrentPositionComponent.propTypes = {
  turnOnMyLocation: func.isRequired,
  category: array.isRequired,
  radius: number.isRequired,
}

const mapStateToProps = ({ spi, map }) => ({
  category: spi.category,
  radius: map.radius,
})

const mapDispatchToProps = dispatch => ({
  updateLoading: value => dispatch(updateLoading(value)),
  turnOnMyLocation: value => dispatch(turnOnMyLocation(value)),
  addressBasedSearch: value => dispatch(addressBasedSearch(value)),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CurrentPositionComponent)
)



// WEBPACK FOOTER //
// ./src/components/Elements/DeviceEvents/CurrentPosition/CurrentPositionComponent/index.jsx